export function isPromise(p) {
    return !!p && typeof p === 'object' && typeof p.then === 'function';
}
//# sourceMappingURL=promise.js.map